/**
 * Componente de Informações de Configuração PGMQ
 * 
 * Exibe informações sobre a configuração da fila PGMQ:
 * - Nome da fila
 * - Intervalo do worker
 * - Configurações de retry
 * - Links úteis
 */

import { Database, Clock, RefreshCw, Settings, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export function PgmqInfoCard() {
  const configItems = [
    {
      icon: Database,
      label: 'Nome da Fila',
      value: 'flows',
      description: 'Fila principal de processamento',
    },
    {
      icon: Clock,
      label: 'Intervalo do Worker',
      value: '5s',
      description: 'pg_cron executa a cada 5 segundos',
    },
    {
      icon: RefreshCw,
      label: 'Max Retries',
      value: '3',
      description: 'Tentativas antes de mover para DLQ',
    },
    {
      icon: Settings,
      label: 'Visibility Timeout',
      value: '30s',
      description: 'Tempo de lock durante processamento',
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="h-5 w-5" />
          Configuração PGMQ
        </CardTitle>
        <CardDescription>
          Parâmetros da arquitetura Flow Engine 3.0
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {configItems.map((item) => (
          <div key={item.label} className="flex items-start gap-3">
            <div className="p-2 rounded-md bg-muted">
              <item.icon className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium">{item.label}</span>
                <Badge variant="secondary" className="font-mono">
                  {item.value}
                </Badge>
              </div>
              <p className="text-xs text-muted-foreground mt-0.5">
                {item.description}
              </p>
            </div>
          </div>
        ))}

        {/* Links de Documentação */}
        <div className="pt-4 border-t space-y-2">
          <p className="text-sm font-medium text-muted-foreground">
            Documentação
          </p>
          <a 
            href="/Documentacao/Flow_Engine_3.0.md" 
            target="_blank"
            className="flex items-center gap-2 text-sm text-primary hover:underline"
          >
            <ExternalLink className="h-3 w-3" />
            Flow Engine 3.0 (PGMQ)
          </a>
          <a 
            href="https://tembo.io/pgmq" 
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-primary hover:underline"
          >
            <ExternalLink className="h-3 w-3" />
            PGMQ Documentation (Tembo)
          </a>
        </div>
      </CardContent>
    </Card>
  );
}
